module.exports = __webpack_public_path__ + "img/shrewd-save-5.97a36822.jpg";